import {isNil} from 'lodash'

export const getExportValue = (value) => {
  if (isNil(value)) return ''
  let ret = value.toString().replace(/"/g, '""')
  if (ret.search(/("|,|\n)/g) >= 0) ret = '"' + ret + '"'
  return ret
}

// Generates and 'downloads' a CSV file to the browser with csvData
// csvData: A 2-dimensional array, rows then cells, of the data to export
// fileName: A string of the file name downloaded to the browser
export const generateCSVFile = (csvData, fileName) => {
  const data = csvData.map(row => row.map(cell => getExportValue(cell)).join(',')).join('\n')
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' })

  const link = document.createElement('a')
  link.setAttribute('href', URL.createObjectURL(blob))
  link.setAttribute('download', fileName)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
